// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1804":"48bcb760","4865":"35a48738","5743":"35a48738","7137":"aa784020","7485":"08f28767"}[chunkId] + ".chunk.css";
};